import { UserX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/Select';

interface AnonymousSelectProps {
  isAnonymous: boolean;
  onAnonymousChange: (isAnonymous: boolean) => void;
}

export function AnonymousSelect({
  isAnonymous,
  onAnonymousChange,
}: AnonymousSelectProps): React.ReactElement {
  const { t } = useTranslation('knowledge');

  return (
    <Select
      value={isAnonymous ? 'anonymous' : 'show'}
      onValueChange={(anonymousValue) =>
        onAnonymousChange(anonymousValue === 'anonymous')
      }
    >
      <SelectTrigger className="h-auto min-h-0 w-auto rounded-md border-0 bg-transparent px-2.5 py-2 -mx-2.5 shadow-none hover:bg-black/[0.025] transition-colors [&>svg]:hidden">
        <SelectValue>
          <div className="flex items-center gap-1.5 text-[13px] text-foreground">
            <UserX className="h-3.5 w-3.5 text-muted-foreground" />
            {isAnonymous ? t('anonymous') : t('showMyName')}
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="show">
          <div className="flex items-center gap-1.5">
            <UserX className="h-3.5 w-3.5 text-muted-foreground" />
            {t('showMyName')}
          </div>
        </SelectItem>
        <SelectItem value="anonymous">
          <div className="flex items-center gap-1.5">
            <UserX className="h-3.5 w-3.5 text-muted-foreground" />
            {t('anonymous')}
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
